import React from "react";

const Toast = ({ message, visible }) => (
  <div className={`abr-toast${visible ? " is-show" : ""}`} role="status" aria-live="polite">
    {message}
  </div>
);

export default Toast;
